module.exports = __webpack_public_path__ + "img/vip.25ce2eba.svg";